"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFeatureToggleVariantString = exports.getFeatureToggleVariantList = exports.getFeatureTogglePageProp = exports.FEATURE_TOGGLE_PROP = void 0;
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
exports.FEATURE_TOGGLE_PROP = '_ft';
exports.getFeatureTogglePageProp = (0, libs_next_utils_1.createPagePropGetter)(exports.FEATURE_TOGGLE_PROP, null);
function getFeatureToggleVariantList(variant, name) {
    const strValue = getFeatureToggleVariantString(variant, name);
    return strValue ? strValue.split(',') || [] : null;
}
exports.getFeatureToggleVariantList = getFeatureToggleVariantList;
function getFeatureToggleVariantString(variant, name) {
    const payload = (variant === null || variant === void 0 ? void 0 : variant.name) === name && (variant === null || variant === void 0 ? void 0 : variant.enabled) === true
        ? variant.payload
        : null;
    return payload ? payload.value : null;
}
exports.getFeatureToggleVariantString = getFeatureToggleVariantString;
//# sourceMappingURL=feature-toggle.utils.js.map